export default __webpack_public_path__ + "choose_wiggle_line.8e2c86.svg";